<p
    qpxCell="secondary"
    variant="sm"
    [attr.tabindex]="keyboardFocus() && !canPublish() ? 0 : null"
    [attr.cdkFocusInitial]="keyboardFocus() && !canPublish() ? '' : null"
>
    {{ message() }}
</p>

@if (canPublish()) {
    <button
        cdkFocusInitial
        qpxButton
        matButton="outlined"
        size="sm"
        (click)="onPublishBuildingRequested()"
    >
        <ng-icon qpx name="lucideCloudUpload" matButtonIcon />
        <span>Publish building</span>
    </button>
}
